import storeModule from '@/store';
import { isEmptyObject } from '@/lib/is-empty-object';
import { SUPERANNUATION } from '@/core/field-names';

export function cleanSuperannuation(document, store = storeModule) {
  const SUPER_TYPE = {
    EMPLOYER_NOMINATED: 'employerNominated',
    EMPLOYEE_NOMINATED: 'employeeNominated',
    SELF_MANAGED: 'selfManaged',
  };
  const superAnnuationMap = document.fields.reduce((prev, field) => {
    return {
      ...prev,
      [field.name]: field,
    };
  }, {});

  const fieldName = SUPERANNUATION.SELF_MANAGED_FORM;

  const fieldId = superAnnuationMap[fieldName]?.id;

  const fieldNamesToBeCleared = [
    SUPERANNUATION.FUND_NAME,
    SUPERANNUATION.NAME,
    SUPERANNUATION.TFN,
    SUPERANNUATION.MEMBER_NUMBER,
    SUPERANNUATION.DECLARATION,
  ];

  if (
    superAnnuationMap[SUPERANNUATION.TYPE].value === SUPER_TYPE.SELF_MANAGED
  ) {
    fieldNamesToBeCleared.forEach((fieldName) => {
      superAnnuationMap[fieldName].value = null;
      superAnnuationMap[fieldName].valueObj = {};
    });
  } else {
    if (
      superAnnuationMap[SUPERANNUATION.TYPE].value ===
      SUPER_TYPE.EMPLOYER_NOMINATED
    ) {
      superAnnuationMap[SUPERANNUATION.MEMBER_NUMBER].value = null;
      superAnnuationMap[SUPERANNUATION.MEMBER_NUMBER].valueObj = {};
    }

    if (
      superAnnuationMap[fieldName]?.fileValue &&
      !isEmptyObject(superAnnuationMap[fieldName]?.fileValue)
    ) {
      const payload = {
        fileId: store.getters['FileHandler/getFileId']({ fieldName, fieldId }),
        fieldId,
        onboardingId: store.state.onboardingId,
      };

      store.dispatch('FileHandler/delete', payload);

      superAnnuationMap[fieldName].value = null;
      superAnnuationMap[fieldName].valueObj = {};
      superAnnuationMap[fieldName].fileValue = {};
    }
  }
  return document;
}
